export interface Testimonial {
  id: number;
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar?: string;
}

export const testimonialsData: Testimonial[] = [
  {
    id: 1,
    name: "Maria Silva",
    role: "Mãe de 3 filhos",
    content: "O Magistral transformou como cuidamos da saúde da nossa família. Agora nunca esquecemos os horários dos medicamentos homeopáticos e as crianças adoram o sistema de pontos!",
    rating: 5,
    avatar: "/Imagens/Maria Silva.png",
  },
  {
    id: 2,
    name: "Dr. Carlos Mendes",
    role: "Médico Homeopata",
    content: "Recomendo o Magistral para todos os meus pacientes. A organização dos tratamentos e o acompanhamento da evolução facilitam muito o trabalho clínico.",
    rating: 5,
    avatar: "/Imagens/Dr Carlos Mendes.png",
  },
  {
    id: 3,
    name: "Ana Paula Costa",
    role: "Avó e cuidadora",
    content: "Com 68 anos, achei que seria difícil usar um aplicativo, mas o Magistral é muito simples! Agora consigo cuidar dos meus netos com mais segurança.",
    rating: 5,
    avatar: "/Imagens/Ana Paula Costa.png",
  },
  {
    id: 4,
    name: "João Santos",
    role: "Pai solo",
    content: "Como pai solo de duas meninas, o Magistral me deu a organização que eu precisava. Os lembretes são perfeitos e nunca mais perdi um horário de medicamento.",
    rating: 5,
    avatar: "/Imagens/Joao Santos.png",
  },
  {
    id: 5,
    name: "Fernanda Oliveira",
    role: "Terapeuta holística",
    content: "Uso o Magistral tanto para minha família quanto para orientar meus clientes. A interface é linda e a funcionalidade é excelente para acompanhar tratamentos longos.",
    rating: 5,
    avatar: "/Imagens/Fernanda Oliveira.png",
  },
  {
    id: 6,
    name: "Roberto Lima",
    role: "Aposentado",
    content: "Depois dos 60, a memória não é mais a mesma. O Magistral me ajuda a manter meu tratamento homeopático em dia e ainda me motiva com os pontos!",
    rating: 5,
    avatar: "/Imagens/Roberto Lima.png",
  }
];